module.exports = __webpack_public_path__ + "static/reviewer_7-0a6aedc82c72152169513049f399d019.png";